import React from 'react';
import { 
    StyledContainer,
    BackgroundContainer,
    SectionName, 
    SectionTitle,
    SectionDescription
} from '../../Home.styles';

export function HowItWorks() {
    return (
        <BackgroundContainer>
            <StyledContainer>
                <SectionName>how it works</SectionName>
                <SectionTitle>Our algorithms work in your behalf</SectionTitle>
                <SectionDescription>
                    Our skilled engineers have configured a complex probability algorithm taking into consideration the distances between targeted users and selected locations. This completely works in your favor by promoting your products to your intended customers, while maximizing value of each dollar spent on marketing and advertisement on DoveMed platforms. 
                </SectionDescription>   
            </StyledContainer>
        </BackgroundContainer>
    )
}
